import React, { Fragment, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ModalMessage from '../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';

const ColorStateAdmision = ({ admision, openState, setOpenState, changeColorState }) => {

    const [colorValue, setColorValue] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const updateColor = () => {
        
        console.log(colorValue);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/estado-imagenes', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_admision: admision.id_admision, estado: parseInt(colorValue) })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {                
                changeColorState(colorValue);
            }).catch((e) => {
                console.error(e);
            });
    }

    return (
        <Fragment>
            <Modal
                disableEnforceFocus={true}
                open={openState}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="modal-colors" style={{ margin: 5 }}>
                    <IconButton style={{ float: 'right' }} onClick={() => {
                        setOpenState(false);
                    }}>
                        <CloseIcon />
                    </IconButton>
                    <div className="card__title">
                        <h5 className="bold-text">Seleccione el Estado </h5>
                    </div>
                    <div className="form" style={{ flexDirection: 'column' }}>
                        <FormControl component="fieldset" >
                            <RadioGroup
                                defaultValue={colorValue}
                                aria-label="state"
                                name="state-adm"
                                onChange={e => { setColorValue(e.target.value) }}
                            >
                                <FormControlLabel value="1" control={<Radio style={{ color: '#D53E3E' }} />} label="Hozpitalizado" />
                                <FormControlLabel value="2" control={<Radio style={{ color: '#3D8BF3' }} />} label="Le falta algo" />
                                <FormControlLabel value="3" control={<Radio style={{ color: '#70D52F' }} />} label="Todo Ok" />
                            </RadioGroup>
                        </FormControl>
                    </div>                   
                    <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpenModal(true);
                            //changeColorState(colorValue); 
                        }}
                    >
                        Guardar
                    </Button>
                    <ModalMessage
                        color="warning"
                        title="¿Esta seguro?"
                        message="¿Desea cambiar el estado de esta admision?"
                        modal={openModal}
                        toggle={() => { setOpenModal(false); }}
                        onOk={() => {
                            updateColor();
                        }}
                    />
                </div>
            </Modal>
        </Fragment>
    );
}

export default ColorStateAdmision;